
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/github-for-kids",
      function () {
        return require("private-next-pages/courses/github-for-kids.tsx");
      }
    ]);
  